module.exports = __webpack_public_path__ + "img/persistence-small-light.1b6c0304.svg";